import axios from 'axios';

const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*.()])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ROLE_SELLER = 'seller';
const ROLE_DESIGNER = 'designer';
const TOKEN_TYPE = 'sms_noprofile';

const emptyUser = () => ({
  phone: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  email: '',
  password: '',
  passwordConfirm: '',
  checkedRules: false,
  checkedPers: false,
  role: null,
  type: null,
  inn: '',
  companyName: '',
  urAddress: '',
  factAddress: '',
  dealer_centre: '',
  city_id: null,
});

export default {
  data() {
    return {
      user: emptyUser(),
      cityTitle: '',
      pageRules: null,
      pagePers: null,
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => emailPattern.test(v) || 'Поле E-mail заполнено с ошибками',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        inn: v => (!v || !v.length || !this.user.type
         || v.length >= (this.user.type === 'ООО' ? 10 : 12)) || 'ИНН заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      suggestions: [],
      addresses: [],
      cities: [],
      searchCity: '',
      types: ['ООО', 'ИП'],
      ROLE_SELLER,
      ROLE_DESIGNER,
    };
  },
  watch: {
    'user.password': (value) => {
      const messageWrapper = document.getElementById('password_msg');
      if (!messageWrapper) return;
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.$store.getters.ax.post('profiles/api/location/cities', { term: city, limit: 30 })
          .then((result) => {
            app.cities = result.data.cities;
          });
      }
    },
    'user.inn': function watchInn(val) {
      if (this.user.role !== ROLE_SELLER) return;
      if (val && val.length >= 10) {
        this.$store.getters.axl.post('profiles/api/dealers/find-by-inn', { inn_search: val, type_id: 1 })
          .then((result) => {
            const company = result.data.data[0];
            if (company) {
              this.user.companyName = company.organization_name;
              this.user.urAddress = company.address;
            }
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  computed: {
    step() {
      if (!this.token) {
        return this.sentCode ? 'code' : 'phone';
      }
      if (!this.user.role) {
        return 'role';
      }
      return 'form';
    },
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id)?.focus();
      });
    },
    Reset() {
      this.user = emptyUser();
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.pageRules = null;
      this.pagePers = null;
      this.cityTitle = '';
      this.cities = [];

      this.Focus('regPhone');
    },
    SelectRole(role) {
      this.user.role = role;
      this.$nextTick(() => {
        this.Focus('regLastName');
      });
    },
    SendCode() {
      const app = this;
      app.code = '';
      app.$store.getters.axl.post('api/token/get-sms', { type: TOKEN_TYPE, phone: app.user.phone })
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    CheckCode() {
      const app = this;
      app.$store.getters.axl.post('api/token/check-sms', {
        type: TOKEN_TYPE,
        code: app.code,
        phone: app.user.phone,
      })
        .then((response) => {
          app.token = response.data.token;
          app.LoadRegisterInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    LoadRegisterInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pageRules = response.data.pageRules || null;
          app.pagePers = response.data.pagePers || null;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }
      // дизайнеру не нужны seller-поля
      if (formData.role === ROLE_DESIGNER) {
        delete formData.type;
        delete formData.inn;
        delete formData.companyName;
        delete formData.urAddress;
        delete formData.factAddress;
        delete formData.dealer_centre;
      } else {
        delete formData.city_id;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then(async (response) => {
          app.$store.commit('SetLogged', response.data);
          await app.$store.dispatch('GetProfile');
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Регистрация выполнена. Ваш профиль ожидает подтверждения администратором.');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AutocompleteSelect() {
      // ничего дополнительно не делаем — value уже в user.factAddress
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
  },
};
